import { render, staticRenderFns } from "./AssetGenericCardMinimalistComponent.vue?vue&type=template&id=21dc1db9&"
import script from "./AssetGenericCardMinimalistComponent.vue?vue&type=script&lang=js&"
export * from "./AssetGenericCardMinimalistComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports